/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-small[_ngcontent-%COMP%]{width:18px!important;height:18px!important}.container-fluid[_ngcontent-%COMP%]{padding-right:0;padding-left:0}.img-fluid[_ngcontent-%COMP%]{max-width:100%;width:100%}.headerTitle[_ngcontent-%COMP%]{font-size:22px}a.navbar-brand[_ngcontent-%COMP%]{font-size:26px}"];
export { styles as styles };
